export default class ScorecardCreationViewModel {
    public id: number = 0;
    public sections: ScorecardCreationSectionViewModel[] = [];
}

export class ScorecardCreationSectionViewModel {
    public id: number = 0;
    public sectionTitle: string = '';
    public sortOrder: number = 0;
    public dependencyJSON: string = '';
    public description: string = '';
    public productTypeFilter: string = '';
    public toggleable: boolean = false;
    public templateId: number = 0;
    public page: number = 1;
    public questions: ScorecardCreationQuestionViewModel[] = [];

    constructor(templateId: number) {
        this.templateId = templateId;
    }
}

export class ScorecardCreationQuestionViewModel {
    public id: number = 0;
    public questionText: string = '';
    public category: string = '';
    public subCategory: string = '';
    public clientCategory: string = '';
    public criticalFail: boolean | null = false;
    public description: string = '';
    public sortOrder: number = 0;
    public dependencyJSON: string = '';
    public sectionId: number = 0;
    public type: string = '';
    public customJSON: string | null = null;
    public dependencyTag: string = '';
    public dependentQuestions: string = '';
    public groupQuestion: boolean = false;
    public outcomeFlag: boolean = false;
    public tenureFlag: boolean = false;

    constructor(sectionId: number) {
        this.sectionId = sectionId;
    }
}